import { getYandexMetricsOptionsFromSravniTMOptions, convertOptionsToDefaultValues, getGtmOptionsFromSravniTMOptions } from './helpers/index.js';
import { defineFromSravniToSravniTM, defineFromGTMToSravniTM, defineFromSravniTMToYandexMetrics } from './helpers/dataConvertors.js';
import { defineGTM } from './helpers/gtm.js';
import { defineSravniTM } from './helpers/sravniTm.js';
import { defineYandexMetrics } from './helpers/yandex.js';

/**
 * Initialize analytic scripts
 * @param {ISravniTMOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initSravniTM({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */
const initSravniTM = (options) => {
    const gtmOptions = getGtmOptionsFromSravniTMOptions(options);
    const yandexMetricsOptions = getYandexMetricsOptionsFromSravniTMOptions(options);
    const dataLayer = 'sravniDataLayer';
    const googleDataLayer = 'dataLayer';
    const defaultData = convertOptionsToDefaultValues(options);
    const response = [
        `window['${dataLayer}'] = window['${dataLayer}'] || []`,
        `window['${googleDataLayer}'] = window['${googleDataLayer}'] || []`,
        ...defaultData.map((item) => `window['${dataLayer}'].push(${JSON.stringify(item)})`),
        defineGTM(gtmOptions, googleDataLayer),
        defineYandexMetrics(yandexMetricsOptions, dataLayer),
        defineSravniTM({
            dataLayer,
            googleDataLayer,
            yandexId: yandexMetricsOptions.id,
        }),
        defineFromSravniToSravniTM(dataLayer),
        defineFromGTMToSravniTM(dataLayer),
        defineFromSravniTMToYandexMetrics(dataLayer, yandexMetricsOptions.id),
    ];
    return response.join(';\n');
};

export { initSravniTM };
//# sourceMappingURL=analytics.js.map
